module.exports = __webpack_public_path__ + "static/logo-philip-morris-international-a1b7e166103d7b240f633df9d127d416.png";